module.exports = __webpack_public_path__ + "img/kpi-user.b52bb969.svg";